export const commonEnvironment = {
  /**指纹收费版接口域名 */
  fpEndpoint: 'https://finger-api.kzxdwqpl.com',
  /**指纹收费版js域名 */
  fpEndpointJS: 'https://fiuspzry.athena25.com',
  /**指纹收费版apikey */
  fpApiKey: 'yErsUE2mIRfiHO0YXk4Z',
};
